import styled from 'styled-components';

import { colors, transition } from 'theme/theme';

export const TabSwitcherContainer = styled.div`
  overflow: hidden;
  position: relative;
`;

export const TabSwitcherTabsContainer = styled.div`
  display: flex;
  overflow: auto;
  gap: 20px;

  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const TabSwitcherIndicator = styled.div`
  position: absolute;
  bottom: 0;
  overflow: hidden;
  height: 2px;
  background: ${colors.brandBlue};
  transition: ${transition};
  z-index: 2;
`;
